import { render, staticRenderFns } from "./IconUserMultiple.vue?vue&type=template&id=20fdd286"
import script from "./IconUserMultiple.vue?vue&type=script&lang=js"
export * from "./IconUserMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports